module.exports = __webpack_public_path__ + "img/player_skeleton.caeb27cb.png";